// Estado global (Zustand). Persiste tema, selección favorita y la simulación de la
// llave en localStorage (clave 'm26-prefs') → queda guardado en el dispositivo.
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ThemeName = 'dark' | 'light';

// Picks de la simulación: num de partido -> nombre del equipo elegido ganador.
export type BracketPicks = Record<number, string>;

interface AppState {
  theme: ThemeName;
  favorite: string | null;
  bracketPicks: BracketPicks;
  toggleTheme: () => void;
  setFavorite: (team: string | null) => void;
  setBracketPicks: (picks: BracketPicks) => void;
  resetBracket: () => void;
}

export const useStore = create<AppState>()(
  persist(
    (set, get) => ({
      theme: 'dark',
      favorite: null,
      bracketPicks: {},
      toggleTheme: () => set({ theme: get().theme === 'dark' ? 'light' : 'dark' }),
      setFavorite: (team) => set({ favorite: get().favorite === team ? null : team }),
      setBracketPicks: (picks) => set({ bracketPicks: picks }),
      resetBracket: () => set({ bracketPicks: {} }),
    }),
    { name: 'm26-prefs' }
  )
);
